export default {

  create(_, data, BACKEND) {
    return {
      finishDatesArray:  data.finishDates, // time in seconds
    }
  },

  fields: {
    finishDatesArray: { validate_bolt_type: 'JSON' },
  }
};
